"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandPartnerComponent = void 0;
const core_1 = require("@angular/core");
const version_service_1 = require("./version.service");
const version_pipe_1 = require("./version.pipe");
const demand_partner_service_1 = require("./demand-partner.service");
const notification_service_1 = require("./notification.service");
const permission_service_1 = require("./permission.service");
const demand_partner_1 = require("./demand-partner");
const events_1 = require("./events");
let DemandPartnerComponent = class DemandPartnerComponent {
    constructor(_v, _version, _partnerService, _talk, _permission) {
        this._v = _v;
        this._version = _version;
        this._partnerService = _partnerService;
        this._talk = _talk;
        this._permission = _permission;
        this.userHover = false;
        this.demandPartner = new demand_partner_1.DemandPartner;
        this.container = {};
        this.type = '';
        this.demandPartnerRemove = new core_1.EventEmitter();
        this.permission = JSON.parse(JSON.stringify(_permission.get()));
    }
    ngOnInit() {
        this.versions = { adEngine: this._v.getBiddrPlusVersion(), generator: this._v.getApplicationVersion() };
        let vFields = this._version.transform(this.demandPartner.fields, this.versions.adEngine);
        for (let f in vFields) {
            if (vFields[f].required && (typeof vFields[f].value == 'undefined')) {
                this.demandPartner.expanded = true;
                break;
            }
        }
    }
    pauseDemandPartner() {
        this.demandPartner.enabled = !this.demandPartner.enabled;
        this.events.add({
            subFeature: events_1.EventSubFeature.demandPartner,
            subject: this.demandPartner.code,
            subjectID: this.demandPartner.id,
            action: this.demandPartner.enabled ? events_1.EventAction.enabled : events_1.EventAction.disabled
        });
    }
    confirmDemandPartnerDelete(demandPartner, deleteDetails) {
        this._talk.confirm(`Are you sure you want to delete ${demandPartner.displayName || 'this'}  demand partner?`)
            .then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result.then(result => {
                    if (result) {
                        this.events.add({
                            subFeature: events_1.EventSubFeature.demandPartner,
                            subject: this.demandPartner.code,
                            subjectID: this.demandPartner.id,
                            action: events_1.EventAction.deleted
                        });
                        return this.deleteDemandPartner(demandPartner, deleteDetails);
                    }
                });
        })
            .catch((err) => { }); //just to avoid unhandled error on window
    }
    deleteDemandPartner(demandPartner, deleteDetails) {
        Promise.resolve()
            .then(() => {
            let partnerId = this.isCopy ? undefined : demandPartner.adUnitPartnerId;
            let isExistingPartner = this.isCopy ? false : !!demandPartner.adUnitPartnerId;
            //if existing, we just need to delete the local references
            if (!isExistingPartner)
                return null;
            if (!partnerId && isExistingPartner)
                throw new Error('Missing demandPartnerId');
            return this._partnerService.deletePartner(partnerId);
        })
            .then(() => {
            //Update local containers references 
            switch (deleteDetails.updateContainerBy) {
                case 'type':
                    switch (deleteDetails.operation) {
                        case 'splice':
                            this.container.demandPartners[deleteDetails.partnerType].splice(deleteDetails.index, 1); // remove the correct demand partner if there are duplicates
                            break;
                        case 'filter':
                            this.container.demandPartners[deleteDetails.partnerType] = this.container.demandPartners[deleteDetails.partnerType].filter(dP => dP.displayName != this.demandPartner.displayName);
                            this.demandPartnerRemove.emit(this.demandPartner);
                            break;
                        default:
                            console.warn('DemandPartnerDelete: Invalid delete type operation:', deleteDetails.operation);
                            break;
                    }
                    break;
                case 'all':
                    this.container.demandPartners = this.container.demandPartners.filter(dP => dP.displayName != this.demandPartner.displayName);
                    this.demandPartnerRemove.emit(this.demandPartner);
                    break;
                default:
                    console.warn('DemandPartnerDelete: Invalid delete update container operation', deleteDetails.updateContainerBy);
                    break;
            }
        })
            .catch((err) => {
            console.error('Error deleting demand partner', err);
            this._talk.broadcast(`<h1>Oops! We were to unable to delete this demand partner.</h1>`);
        });
    }
    removeDemandPartner() {
        let demandPartnerType = this.demandPartner.type.type;
        let demandPartners = this.container.demandPartners;
        if (demandPartners && demandPartners[demandPartnerType]) {
            // if DemandPartners is split into multiple types, i.e. "Client" and "Server"
            demandPartners = demandPartners[demandPartnerType];
            let duplicateDPs = demandPartners.filter(existingDP => existingDP.displayName == this.demandPartner.displayName);
            if (duplicateDPs.length > 1) {
                for (let dp = 0; dp < demandPartners.length; dp++) {
                    if (demandPartners[dp].displayName == this.demandPartner.displayName) {
                        if (demandPartners[dp].dpNum == this.demandPartner.dpNum) {
                            this.confirmDemandPartnerDelete(demandPartners[dp], { updateContainerBy: 'type', operation: 'splice', partnerType: demandPartnerType, index: dp });
                            break;
                        }
                        if (demandPartners[dp].dpNum >= this.demandPartner.dpNum) {
                            demandPartners[dp].dpNum--; // adjust the # used to track duplicates since one was removed
                        }
                    }
                }
            }
            else {
                // if no duplicates, then just remove it
                this.confirmDemandPartnerDelete(this.demandPartner, { updateContainerBy: 'type', operation: 'filter', partnerType: demandPartnerType });
            }
        }
        else {
            // if DemandPartners is just an array
            this.confirmDemandPartnerDelete(this.demandPartner, { updateContainerBy: 'all', operation: 'filter' });
        }
    }
};
exports.DemandPartnerComponent = DemandPartnerComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", demand_partner_1.DemandPartner)
], DemandPartnerComponent.prototype, "demandPartner", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DemandPartnerComponent.prototype, "container", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DemandPartnerComponent.prototype, "type", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], DemandPartnerComponent.prototype, "isCopy", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", events_1.ControlCenterEvents)
], DemandPartnerComponent.prototype, "events", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], DemandPartnerComponent.prototype, "demandPartnerRemove", void 0);
exports.DemandPartnerComponent = DemandPartnerComponent = __decorate([
    (0, core_1.Component)({
        selector: 'myDemandPartner',
        templateUrl: 'app/demand-partner.component.html'
    }),
    __metadata("design:paramtypes", [version_service_1.VersionService,
        version_pipe_1.VersionPipe,
        demand_partner_service_1.DemandPartnerService,
        notification_service_1.NotificationService,
        permission_service_1.PermissionService])
], DemandPartnerComponent);
//# sourceMappingURL=demand-partner.component.js.map